import React from 'react';
import {
  FormControl,
  FormLabel,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { BULMA_COLORS, BULMA_SIZES, BULMA_STYLES, BULMA_STATES } from '../constants/selectConstants';

export const BulmaSettings = ({ 
  bulmaColor, bulmaSize, bulmaStyle, bulmaState, 
  isMultiple, multipleSize, setProp 
}) => (
  <Accordion defaultExpanded>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="subtitle2">Bulma Styling</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormControl fullWidth margin="normal">
        <FormLabel>Color</FormLabel>
        <Select
          value={bulmaColor || ''}
          onChange={(e) => setProp(props => props.bulmaColor = e.target.value)}
          size="small"
        >
          {BULMA_COLORS.map(color => (
            <MenuItem key={color.value} value={color.value}>{color.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Size</FormLabel>
        <Select
          value={bulmaSize || ''}
          onChange={(e) => setProp(props => props.bulmaSize = e.target.value)}
          size="small"
        >
          {BULMA_SIZES.map(size => (
            <MenuItem key={size.value} value={size.value}>{size.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Style</FormLabel>
        <Select
          value={bulmaStyle || ''}
          onChange={(e) => setProp(props => props.bulmaStyle = e.target.value)}
          size="small"
        >
          {BULMA_STYLES.map(style => (
            <MenuItem key={style.value} value={style.value}>{style.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>State</FormLabel>
        <Select
          value={bulmaState || ''}
          onChange={(e) => setProp(props => props.bulmaState = e.target.value)}
          size="small"
        >
          {BULMA_STATES.map(state => (
            <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Checkbox
            checked={isMultiple}
            onChange={(e) => setProp(props => props.isMultiple = e.target.checked)}
          />
        }
        label="Multiple selection"
      />

      {isMultiple && (
        <FormControl fullWidth margin="normal">
          <FormLabel>Multiple Size (visible options)</FormLabel>
          <TextField
            value={multipleSize || 8}
            onChange={(e) => setProp(props => props.multipleSize = parseInt(e.target.value) || 8)}
            size="small"
            type="number"
            inputProps={{ min: 2, max: 20 }}
          />
        </FormControl>
      )}
    </AccordionDetails>
  </Accordion>
);